const styles = theme => ({
  root: {
    //width: "70%"
    //textAlign: "right"
  }
});

export default styles;
